export default {
  row: 'Row',
  rows: 'Rows',
  verbose_row: 'a row',
  general_info: 'General information',

  columns: 'Columns',
  layout: 'Layout',
  gutters: 'Remove gutters between grid elements',
  contained: 'Contained at center of page with max width',
};
